export default "__VITE_ASSET__CDJCfBcc__"